import React, { useState } from "react";
import Popover from "./ui/Popover/Popover";
import Button from "./ui/Button";
// import { useNavigate } from "react-router";
import catalogSvg from '../assets/catolg_icon.svg';


interface Category {
  id: number;
  name: string;
  parent_id: string;
  ref_key: string;
  description: string;
  created_at: string;
  updated_at: string;
  children: Category[];
}

interface CategoriesMenuProps {
  categories: Category[];
}

export const CategoriesMenu = ({ categories }: CategoriesMenuProps) => {
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);

  // Функция для обработки выбора категории
  const handleCategoryClick = (category: Category) => {
    if (category.children && category.children.length > 0) {
      setSelectedCategory(category);
    } else {
      // Переход по ссылке, если нет дочерних категорий
      window.location.href = `/category/${category.ref_key}`;
    }
  };

  // Функция для обработки показа дочерних категорий
  const renderChildrenCategories = (category: Category) => {
      return (
        <div className="grid grid-cols-2 gap-1">
        <a
            key={category.ref_key}
            href={`/category/${category.ref_key}`}
            className="p-1 hover:text-[#383181] text-[16px]"
          >
            {category.name}
          </a>
          {category.children.map((child) => (
            <a
              key={child.ref_key}
              href={`/category/${child.ref_key}`}
              className="p-1 hover:text-[#383181] text-[16px]"
            >
              {child.name}
            </a>
          ))}
        </div>
      );
  };

  return (
    <div>
      {/* Кнопка для открытия Popover */}
      <Popover
        button={
          <Button style="primary" className="flex-shrink-0 flex-row flex space-x-2 w-[148px] cursor-pointer !rounded-[15px] !p-[14px] h-[55px] text-center items-center justify-center">
            <img src={catalogSvg} alt="" className="w-[23px] h-[16px]" />
            <span className="text-[18px] font-semibold">Каталог</span>
          </Button>
        }
        position="bottom"
        panelClassName="w-[800px] max-h-[500px] bg-white shadow-lg rounded-md overflow-hidden"
      >
        <div className="flex h-full">
          {/* Список основных категорий */}
          <div className="w-1/3 border-r bg-[#F7F9FC] border-gray-200 overflow-y-auto max-h-[500px]">
            {categories.map((category) => (
              <div
                key={category.ref_key}
                className={`px-4 py-3 cursor-pointer hover:bg-gray-100 ${
                  selectedCategory?.id === category.id
                    ? "bg-gray-200 text-[#383181]"
                    : ""
                }`}
                onClick={() => handleCategoryClick(category)}
                onPointerEnter={() => {
                  setSelectedCategory(category);
                }}
              >
                {category.name}
              </div>
            ))}
          </div>

          {/* Список дочерних категорий */}
          <div className="w-2/3 p-4 overflow-y-auto max-h-[500px]">
            {selectedCategory ? (
              renderChildrenCategories(selectedCategory)
            ) : (
              <div className="text-gray-500 text-center">
                Выберите категорию, чтобы увидеть подкатегории
              </div>
            )}
          </div>
        </div>
      </Popover>
    </div>
  );
};
